function TextContent({ children }: { children: string | JSX.Element }) {
  return (
    <div className="text-base font-normal text-[#DCDCDC] xl:max-w-[94%] 3xl:max-w-[85%]">
      {children}
    </div>
  );
}

export default TextContent;
